import styled from 'styled-components';
import { Radio } from 'antd';


export const Container = styled.div`
	display: flex;
	
	margin: 20px;
		
	font-weight: 500;

	white-space: nowrap;
	max-width: 100%;

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		margin: 0px 20px;
	};

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phoneTiny}px) {
		margin: 0px 5px;
	};
`;

export const Title = styled.div`
	margin-right: 15px;
	flex-shrink: 0;
`;

export const StyledRadioGroup = styled(Radio.Group)`

	.ant-radio:hover {
		border-color: ${({theme}) => theme.colors.fallow}; 
	}
	
	.ant-radio-checked .ant-radio-inner {
		border-color: ${({theme}) => theme.colors.fallow}; 
		
		:after {
			background-color: ${({theme}) => theme.colors.fallow}; 
		}
	}
	
	.ant-radio-wrapper {
		font-size: 12px;
		width: 65px;
		
		span:last-child {
		  opacity: 0.8;
		}
		
		&.ant-radio-wrapper-checked {
      span:last-child {
        opacity: unset;
      }
	  }
	}

	@media (max-width: ${(props) => props.theme.mediaQueryConstants.phone}px) {
		.ant-radio-wrapper {
			width: unset;
		}
	};
`;
